const LOGIN_FLOW_BASE = 'login/loginFlowStatus';
export default Object.freeze({
    LOGIN_FLOW: LOGIN_FLOW_BASE,
    LOGIN_FLOW_PENDING: `${LOGIN_FLOW_BASE}/pending`,
    LOGIN_FLOW_FULFILLED: `${LOGIN_FLOW_BASE}/fulfilled`,
    LOGIN_FLOW_REJECTED: `${LOGIN_FLOW_BASE}/rejected`,
});
